import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import useSWR from "swr";
import { Box, Link, Skeleton, TableContainer, Typography } from "@mui/material";
import { fetchData } from "../../../../lib/dashboard/data";
import NotFound from "../../../../components/notfound/NotFound";

export default function PETable() {
  const { data = [], isLoading } = useSWR("/dashboard/pe", fetchData, {
    revalidateOnFocus: false,
    dedupingInterval: 60 * 1000,
  });

  return (
    <Paper sx={{ height: 300 }}>
      {data.length < 1 ? (
        <Box sx={{ height: "100%" }}>
          <NotFound />
        </Box>
      ) : (
        <>
          <Typography sx={{ mb: 2, fontWeight: 700 }}>P/E</Typography>
          <Tbl data={data} isLoading={isLoading} />
        </>
      )}
    </Paper>
  );
}

const Tbl = ({ data, isLoading }) => {
  const cols = Object.values({
    symbol: "نماد",
    pe: "P/E",
    sector_pe: "P/E گروه",
    market_cap: "ارزش بازار (میلیارد تومان)",
  });

  return (
    <TableContainer sx={{ overflow: "auto", height: "100%" }}>
      <Table size="small" sx={{ tableLayout: "auto", whiteSpace: "nowrap" }}>
        <TableHead>
          <TableRow>
            {cols.map((col) => (
              <TableCell
                sx={{
                  fontWeight: 700,
                  textAlign: "center",
                  whiteSpace: "nowrap",
                }}
                key={col}
              >
                {col}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading
            ? [...Array(5)].map((_, index) => (
              <TableRow key={index}>
                {[...Array(4)].map((_, i) => (
                  <TableCell
                    key={i}
                    sx={{ textAlign: "center", whiteSpace: "nowrap" }}
                  >
                    <Skeleton variant="text" />
                  </TableCell>
                ))}
              </TableRow>
            ))
            : data.map((item) => (
              <TableRow key={item.symbol}>
                <TableCell sx={{ textAlign: "center" }}>
                  <Link href={item.link} component={"a"} target="_blank">
                    {item.symbol}
                  </Link>
                </TableCell>
                <TableCell sx={{ textAlign: "center" }}>{item.pe}</TableCell>
                <TableCell sx={{ textAlign: "center" }}>
                  {item.sector_pe}
                </TableCell>
                <TableCell sx={{ textAlign: "center" }}>
                  {item.market_cap}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
